module.exports = __webpack_public_path__ + "img/call-app.44678800.svg";